/* HK Hero Rotator — verbatim port of the prototype's rotating-hero script
   (happikiddo-storefront/pages/home.html, page-specific JS). Behaviour is
   unchanged: 5500ms autoplay, arrows, dots, hover pause, touch swipe,
   prefers-reduced-motion respected. Wrapped for Shopify: initialises every
   .hero-rotator on the page, guarded against double-init on section reloads
   in the theme editor. */
(function () {
  function initRotator(rotator) {
    if (!rotator || rotator.dataset.hkHeroInit === 'true') return;
    rotator.dataset.hkHeroInit = 'true';

    var slides = [].slice.call(rotator.querySelectorAll('.hero-slide'));
    var dots = [].slice.call(rotator.querySelectorAll('.hero-dot'));
    if (!slides.length || slides.length !== dots.length) return;
    var i = 0, timer = null;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var DELAY = 5500;

    function show(n) {
      n = (n + slides.length) % slides.length;
      slides[i].classList.remove('is-active');
      dots[i].classList.remove('is-active');
      dots[i].setAttribute('aria-selected', 'false');
      i = n;
      slides[i].classList.add('is-active');
      dots[i].classList.add('is-active');
      dots[i].setAttribute('aria-selected', 'true');
    }
    function next() { show(i + 1); }
    function prev() { show(i - 1); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function start() { if (reduce) return; stop(); timer = setInterval(next, DELAY); }

    rotator.querySelector('.hero-arrow-next').addEventListener('click', function () { next(); start(); });
    rotator.querySelector('.hero-arrow-prev').addEventListener('click', function () { prev(); start(); });
    dots.forEach(function (d, idx) { d.addEventListener('click', function () { show(idx); start(); }); });
    rotator.addEventListener('mouseenter', stop);
    rotator.addEventListener('mouseleave', start);

    var x0 = null;
    rotator.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; stop(); }, { passive: true });
    rotator.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) { dx < 0 ? next() : prev(); }
      x0 = null; start();
    }, { passive: true });

    start();
  }

  function initAll(root) {
    [].forEach.call((root || document).querySelectorAll('.hero-rotator'), initRotator);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  /* Shopify theme editor: sections are re-rendered in place. */
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
